import { Box, styled } from "@mui/material";

export const StyledPageComment = styled(Box)(() => ({
  color: "rgb(90, 104, 114)",
  fontSize: "16px",
  fontFamily: "Roboto-Regular",
  fontWeight: "normal",
  letterSpacing: "0.44px",
  lineHeight: "24px"
}));
